<template>
  <div>
    <b-tabs>
      <b-tab title="Economy">
        <b-row>
          <b-col sm="12">
            <EngagedDrivers service-type="economy" />
          </b-col>
          <b-col md="8">
            <CanceledNoDriverFoundWrapper service-type="economy" />
          </b-col>
          <b-col
            md="4"
            sm="12"
          >
            <OnlineDriversWithoutTrips service-type="economy" />
          </b-col>
        </b-row>
        <b-card>
          <TripsStats service-type="economy" />
          <hr class="my-3">
          <driver-stats-aggs service-type="economy" />
        </b-card>
      </b-tab>
      <b-tab title="Economy Plus">
        <b-row>
          <b-col sm="12">
            <EngagedDrivers service-type="ecoplus" />
          </b-col>
          <b-col md="8">
            <CanceledNoDriverFoundWrapper service-type="ecoplus" />
          </b-col>
          <b-col
            md="4"
            sm="12"
          >
            <OnlineDriversWithoutTrips service-type="ecoplus" />
          </b-col>
        </b-row>
        <b-card>
          <TripsStats service-type="ecoplus" />
          <hr class="my-3">
          <driver-stats-aggs service-type="ecoplus" />
        </b-card>
      </b-tab>
      <b-tab title="Taxi">
        <b-row>
          <b-col sm="12">
            <EngagedDrivers service-type="taxi" />
          </b-col>
          <b-col md="8">
            <CanceledNoDriverFoundWrapper service-type="taxi" />
          </b-col>
          <b-col
            md="4"
            sm="12"
          >
            <OnlineDriversWithoutTrips service-type="taxi" />
          </b-col>
        </b-row>
        <b-card>
          <TripsStats service-type="taxi" />
          <hr class="my-3">
          <driver-stats-aggs service-type="taxi" />
        </b-card>
      </b-tab>
      <b-tab title="Delivery Box">
        <b-row>
          <b-col sm="12">
            <EngagedDrivers service-type="box" />
          </b-col>
          <b-col md="8">
            <CanceledNoDriverFoundWrapper service-type="box" />
          </b-col>
          <b-col
            md="4"
            sm="12"
          >
            <OnlineDriversWithoutTrips service-type="box" />
          </b-col>
        </b-row>
        <b-card>
          <TripsStats service-type="box" />
          <hr class="my-3">
          <driver-stats-aggs service-type="box" />
        </b-card>
      </b-tab>
      <b-tab title="Bekam">
        <b-row>
          <b-col sm="12">
            <EngagedDrivers service-type="bekam" />
          </b-col>
          <b-col md="8">
            <CanceledNoDriverFoundWrapper service-type="bekam" />
          </b-col>
          <b-col
            md="4"
            sm="12"
          >
            <OnlineDriversWithoutTrips service-type="bekam" />
          </b-col>
        </b-row>
        <b-card>
          <TripsStats service-type="bekam" />
          <hr class="my-3">
          <driver-stats-aggs service-type="bekam" />
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import useRegisterStoreModule from '../../hooks/useRegisterStoreModule'
import tripsStore from '../trips/store'
import driverStore from '../driver/driverStoreModule'
import DriverStatsAggs from './DriversStatsAggs.vue'
import TripsStats from './TripsStats.vue'
import EngagedDrivers from './EngagedDrivers.vue'
import OnlineDriversWithoutTrips from './OnlineDriversWithoutTrips.vue'
import CanceledNoDriverFoundWrapper from './canceled-no-driver-found/Wrapper.vue'

export default {
  components: {
    BCard,
    DriverStatsAggs,
    EngagedDrivers,
    BRow,
    BCol,
    OnlineDriversWithoutTrips,
    CanceledNoDriverFoundWrapper,
    TripsStats,
    BTabs,
    BTab,
  },
  setup() {
    const tabIndex = ref(0)
    useRegisterStoreModule('trips', tripsStore)
    useRegisterStoreModule('drivers', driverStore)
    return { tabIndex }
  },
}
</script>
